export function addHeroEnemy(hero){
    return{
        type:'ADD_HERO_ENEMY',
        payload:hero
    }
}